import React from 'react'
import { IconArrowRightShortDefault } from '@mc/design-system'

type HighlightedArrowProps = {
  size?: 'sm' | 'md'
  theme?: 'highlighted' | 'dark' | 'light' | 'darkHighlighted'
  direction?: 'right' | 'left'
}

export const HighlightedArrow = ({
  size = 'md',
  theme = 'highlighted',
  direction = 'right',
}: HighlightedArrowProps) => {
  const iconSize = size === 'sm' ? '12px' : '16px'

  const styles = {
    highlighted: 'bg-c-brand-highlight text-c-text-dark',
    darkHighlighted: 'bg-black text-c-brand-highlight',
    dark: 'bg-black text-c-text-light',
    light: 'bg-c-base-200 text-c-text-dark',
  }

  return (
    <div className={`rounded-full flex p-[2px] ${styles[theme]}`}>
      <IconArrowRightShortDefault
        style={{
          height: iconSize,
          width: iconSize,
          transform: direction === 'left' ? 'rotate(180deg)' : 'none',
        }}
      />
    </div>
  )
}
